import React from 'react'
import SideMenu from '../../../utilities/sideMenu/menu'
import {Container} from "react-bootstrap"
import ClinicalPSP from './psp_clinical/clinical_psp'
import ScrollToTop from "../../../utilities/scroll_to_top/scroll_to_top"
import ClinicalMSA from './clinical_msa/clinical_msa'
import ParkinsonsDisease from "./parkinons_disease"
import UnclassifiedParkinsonism from "./unclassified_parkinsonism"
import Umsars_new from './clinical_msa/umsars_new'
class ClinicalCriteria extends React.Component{
    constructor(props){
        super(props)
        this.state ={
            clinical_psp:{},
            clinical_msa:{},
            clinical_parkinson_disease:{},
            unclassified_parkinsonism:{}
        }
    }
    handleChange = async(field,event)=>{
    
        /*
        If event triggered by form change then setState using event.target accordingly.
        Else setState with "artificial event" created by the clearState Function using event
        */
        const {name,value} = (event.target?event.target:event) 
        
        await this.setState((prevState)=>({
                ...prevState,
                [field]:{
                    ...prevState[field],
                    [name]:value
                }
            }))
        
    
        
    }
    
    componentDidUpdate(prevProps,prevState){
        
            // if(prevState!=this.state){
            //     if(prevState.clinical_psp!=this.state.clinical_psp){
            //         this.props.handler("clinical_psp",this.state.clinical_psp)
            //     }
            //     if(prevState.clinical_msa!=this.state.clinical_msa){
            //         this.props.handler("clinical_msa",this.state.clinical_msa)
            //     }
            //     if(prevState.clinical_parkinson_disease!=this.state.clinical_parkinson_disease){
            //         this.props.handler("clinical_parkinson_disease",this.state.clinical_parkinson_disease)
            //     }
            //     if(prevState.unclassified_parkinsonism!=this.state.unclassified_parkinsonism){
            //         this.props.handler("unclassified_parkinsonism",this.state.unclassified_parkinsonism)
            //     }
            // }
        
    }
  async  componentDidMount(){
        if(this.props.data!=null){
            await this.setState(this.props.data)
        }
    }
   

    render(){
        return(
            <Container fluid>
           
          
            <SideMenu defaultKey={'unclassified_parkinsonism'}>
                <UnclassifiedParkinsonism indexKey={'unclassified_parkinsonism'} title={'Unclassified Parkinsonism' } data={this.props.data!=null ?this.props.data['unclassified_parkinsonism']:null} handler={this.props.handler}  edit={this.props.disabled==true ?true:false}/>
                <ParkinsonsDisease indexKey={'park_disease'} title={'Clinical criteria for parkinson’s disease' } data={this.props.data!=null ?this.props.data['clinical_parkinson_disease']:null} handler={this.props.handler}  edit={this.props.disabled==true ?true:false}/>
                
                <ClinicalPSP indexKey={'clinicalPSP'} title={'PSP Criteria'} data={this.props.data!=null ?this.props.data['clinical_psp']:null} handler={this.props.handlePspMsaAuto}  edit={this.props.disabled==true ?true:false}/>
                <ClinicalMSA indexKey={'clinicalMSA'} title={'MSA Criteria - Old '} data={this.props.data!=null ?this.props.data['clinical_msa']:null} handler={this.props.handlePspMsaAuto}  edit={this.props.disabled==true ?true:false}/>
                <Umsars_new indexKey={'umsars_new'} title={'MSA Criteria - New'} data={this.props.data!=null ?this.props.data['umsars_new']:null} handler={this.props.handleMsaNew}  disabled={this.props.disabled==true ?true:false}/>
           
            
            </SideMenu>
            
            </Container>
        )
    }
}
ClinicalCriteria.defaultProps ={
    data:null
}
export default ClinicalCriteria